import React, {
  useState,
  useCallback,
  useMemo,
  createContext,
  useContext,
} from 'react';
import PropTypes from 'prop-types';

const ViewPortContext = createContext();

export const useViewPort = () => useContext(ViewPortContext);

export const ViewPortProvider = ({ children }) => {
  const [dimension, setDimension] = useState(() => ({
    containerWidth: 0,
    containerHeight: 0,
    blockerWidth: 0,
    blockerHeight: 0,
  }));

  const setContainerDimension = useCallback(({ width, height } = {}) => {
    setDimension(d => ({
      ...d,
      containerWidth: width || 0,
      containerHeight: height || 0,
    }));
  }, []);

  const setBlockerDimension = useCallback(({ width, height } = {}) => {
    setDimension(d => ({
      ...d,
      blockerWidth: width || 0,
      blockerHeight: height || 0,
    }));
  }, []);

  const value = useMemo(
    () => ({
      dimension,
      setContainerDimension,
      setBlockerDimension,
    }),
    [dimension],
  );
  return (
    <ViewPortContext.Provider value={value}>
      {children}
    </ViewPortContext.Provider>
  );
};

ViewPortProvider.propTypes = {
  children: PropTypes.node,
};

ViewPortProvider.defaultProps = {
  children: null,
};

export default {};
